import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Condicao {
  id: number;
  nome: string;
}

export interface Marca {
  id: number;
  nome: string;
}

export interface Categoria {
  id: number;
  nome: string;
}

export interface Modelo {
  id: number;
  nome: string;
  categoriaId: number;
  marcaId: number;
}

export interface ApiResponse {
  codigo: number;
  listaMensagem: string[];
}

export interface BensCadastrarPayload {
  exbePatrimonioId: number;
  numeroDeSerie: string;
  descricao: string;
  usuarioCadastroId: number;
  status: boolean;
  idCategoria: number;
  condicaoBemId: number;
  marcaCadastrar: {
    id: number,
    nome: string,
  };
  modeloCadastrar: {
    id: number;
    nome: string;
    usuarioCadastroId: number;
    categoriaCadastrar: number;
    marcaCadastrar: number;
  };
}

export interface Bens {
  id: number;
  exbePatrimonioId: number;
  numeroDeSerie: string;
  descricao: string;
  ativo: boolean | null;
  categoria: Categoria;
  idCategoria: number;
  modelo: Modelo;
  idModelo: number;
  tipoCondicaoBens: Condicao;
  idTipoCondicaoBens: number;
  marca: Marca;
  idMarca: number;
  usuario: {
    id: number;
    nome: string;
  };
  usuarioCadastroId: number;
  dataCadastro: Date;
  usuarioAlteracao?: {
    id: number;
    nome: string;
  };
  usuarioAlteracaoId?: number;
  dataAlteracao?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class CadastroBensService {

  //private api = 'http://localhost:5283/api';
  private api = environment.apiUrlExbeGuardian;

  constructor(private http: HttpClient) {}

  getCondicoes(): Observable<Condicao[]> {
    return this.http.get<Condicao[]>(`${this.api}/TipoCondicaoBens`);
  }

  cadastrarBens(payload: BensCadastrarPayload): Observable<any> {
    return this.http.post(`${this.api}/Bens`, payload);
  }

  getCategorias(): Observable<Categoria[]> {
    return this.http.get<Categoria[]>(`${this.api}/Categoria`);
  }

  getMarcaPorNome(nome: string): Observable<Marca> {
    return this.http.get<Marca>(`${this.api}/Marca/nome/${encodeURIComponent(nome)}`);
  }

  getMarcas(): Observable<Marca[]> {
    return this.http.get<Marca[]>(`${this.api}/Marca`);
  }

  getModeloPorNome(nome: string): Observable<Modelo> {
    return this.http.get<Modelo>(`${this.api}/Modelo/nome/${encodeURIComponent(nome)}`);
  }

  getModelosPorCategoria(idCategoria: number): Observable<Modelo[]> {
    return this.http.get<Modelo[]>(`${this.api}/Modelo/categoria/${idCategoria}`);
  }

  listarBens(
    categoriaId?: number | null,
    marcaNome?: string | null,
    modeloNome?: string | null,
    nomeUsuario?: string | null
  ): Observable<Bens[]> {
    let params = new HttpParams();

    if (categoriaId) {
      params = params.set('categoriaId', categoriaId.toString());
    }
    if (marcaNome && marcaNome.trim()) {
      params = params.set('marcaNome', marcaNome.trim());
    }
    if (modeloNome && modeloNome.trim()) {
      params = params.set('modeloNome', modeloNome.trim());
    }
    if (nomeUsuario && nomeUsuario.trim()) {
      params = params.set('nomeUsuario', nomeUsuario.trim());
    }

    return this.http.get<Bens[]>(`${this.api}/Bens`, { params });
  }
}
